import React, { useCallback } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@mui/material/InputAdornment";

// material ui icons
import Close from "@mui/icons-material/Close";
import VpnKeyIcon from "@mui/icons-material/VpnKey";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import CardBody from "components/Card/CardBody.js";

// validation
import { verifyLength, verifyEqual } from "helpers/validation";

// styles
import { TitleWrapperStyled, TitleStyled, styles } from "./styles";

// action creators
import { sendChangePassword } from "redux/ducks/changePassword";

const useStyles = makeStyles(styles);

function ChangePassword() {
  const { id } = useParams();
  const dispatch = useDispatch();

  const classes = useStyles();
  let history = useHistory();
  // new form
  const [password, setPassword] = React.useState("");
  const [confirmPassword, setConfirmPassword] = React.useState("");

  // validation state
  const [passwordState, setPasswordState] = React.useState("");
  const [confirmPasswordState, setConfirmPasswordState] = React.useState("");

  // calls
  const sendData = useCallback(
    (id, body) => {
      dispatch(sendChangePassword(id, body));
    },
    [dispatch]
  );

  const handleSubmit = () => {
    if (passwordState === "" || passwordState === "error" || !password) {
      setPasswordState("error");
      return;
    }
    if (
      confirmPasswordState === "" ||
      confirmPasswordState === "error" ||
      !confirmPassword
    ) {
      setConfirmPasswordState("error");
      return;
    }

    let body = {
      password,
    };

    sendData(id, body);
  };

  const handleChangePassword = (event) => {
    if (verifyLength(event.target.value, 6)) {
      setPasswordState("success");
    } else {
      setPasswordState("error");
    }
    setPassword(event.target.value);
  };

  const handleChangeConfirmPassword = (event) => {
    if (verifyEqual(event.target.value, password)) {
      setConfirmPasswordState("success");
    } else {
      setConfirmPasswordState("error");
    }
    setConfirmPassword(event.target.value);
  };

  const handleGoBack = () => {
    history.goBack();
  };

  return (
    <React.Fragment>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="info" icon>
              <CardIcon color="info">
                <VpnKeyIcon />
              </CardIcon>
              <TitleWrapperStyled>
                <TitleStyled>Cambiar contraseña</TitleStyled>
                <Button
                  justIcon
                  round
                  color="info"
                  onClick={() => handleGoBack()}
                >
                  <ArrowBackIcon className={classes.buttonIcon} />
                </Button>
              </TitleWrapperStyled>
            </CardHeader>
            <CardBody>
              <form>
                <CustomInput
                  success={passwordState === "success"}
                  error={passwordState === "error"}
                  labelText="Contraseña *"
                  id="password"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    onChange: (event) => handleChangePassword(event),
                    type: "password",
                    value: password,
                    endAdornment:
                      passwordState === "error" ? (
                        <InputAdornment position="end">
                          <Close className={classes.danger} />
                        </InputAdornment>
                      ) : (
                        undefined
                      ),
                  }}
                />
                <CustomInput
                  success={confirmPasswordState === "success"}
                  error={confirmPasswordState === "error"}
                  labelText="Confirmar contraseña *"
                  id="password"
                  formControlProps={{
                    fullWidth: true,
                  }}
                  inputProps={{
                    onChange: (event) => handleChangeConfirmPassword(event),
                    type: "password",
                    value: confirmPassword,
                    endAdornment:
                      confirmPasswordState === "error" ? (
                        <InputAdornment position="end">
                          <Close className={classes.danger} />
                        </InputAdornment>
                      ) : (
                        undefined
                      ),
                  }}
                />

                <div className={classes.formCategory}>
                  <small>*</small> Campos requeridos
                </div>

                <Button
                  color="info"
                  onClick={handleSubmit}
                  className={classes.registerButton}
                >
                  Guardar
                </Button>
              </form>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </React.Fragment>
  );
}

export default React.memo(ChangePassword);
